import { useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";
import { LitterCard } from "./LitterCard";
import { JoinDialog } from "../profile/LitterBoard";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

export const LitterGrid = ({ items, onChanged, className = "grid sm:grid-cols-2 lg:grid-cols-4 gap-6" }) => {
  const { user, setAuthOpen } = useAuth();
  const { t, lang } = useLanguage();
  const [joining, setJoining] = useState(null);
  const [leaving, setLeaving] = useState(null);
  const onJoin = (l) => (user ? setJoining(l) : setAuthOpen(true));
  const leave = async () => {
    try { await api.delete(`/litters/${leaving.id}/waitlist`); toast.success(t("lt_left_toast")); onChanged(); }
    catch (e) { toast.error(errText(e)); }
    finally { setLeaving(null); }
  };
  return (
    <>
      <div className={className}>
        {items.map((l) => <LitterCard key={l.id} l={l} lang={lang} mine={user?.user_id === l.breeder.user_id} onJoin={onJoin} onLeave={setLeaving} />)}
      </div>
      <JoinDialog litter={joining} onClose={() => setJoining(null)} onJoined={() => { setJoining(null); onChanged(); }} />
      <AlertDialog open={!!leaving} onOpenChange={(o) => !o && setLeaving(null)}>
        <AlertDialogContent className="bg-white" data-testid="waitlist-leave-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display text-[#12234A]">{lang === "fr" ? "Quitter la liste d'attente?" : "Leave this waitlist?"}</AlertDialogTitle>
            <AlertDialogDescription>{lang === "fr" ? "Vous perdrez votre place. Vous pourrez vous réinscrire plus tard, mais en fin de liste." : "You'll lose your spot. You can rejoin later, but you'll go to the back of the line."}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="waitlist-leave-cancel">{t("lt_cancel")}</AlertDialogCancel>
            <AlertDialogAction onClick={leave} data-testid="waitlist-leave-confirm" className="bg-[#F5551E] hover:bg-[#E04812] text-white">{t("lt_leave")}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
